import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {Shared} from "../../../shared/shared";
import {BooleanComponent} from "../../generic/table/booleanComponent/booleanComponent";
import {TextComponent} from "../../generic/table/textComponent/textComponent";
import {DropdownComponent} from "../../generic/table/dropdownComponent/dropdownComponent";
import {TopicEntity} from "../../../../model/TopicEntity";
import {SubjectEntity} from "../../../../model/SubjectEntity";
import {SubjectService} from "../../../../service/SubjectService";
import {StepEntity} from "../../../../model/StepEntity";
import {StepContentEntity} from "../../../../model/StepContentEntity";
import {CalendarService} from "../../../../service/CalendarService";

@Component({
  selector: 'app-step-content',
  templateUrl: 'stepContent.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None
})
export class StepContent {

  @Input() steps: StepEntity[];
  @Input() stepContents: StepContentEntity[];

  @Input() subjects: SubjectEntity[];
  @Input() topics: TopicEntity[];

  @Output() filter = new EventEmitter<number>();

  newEntity: StepContentEntity;
  modeAdd = false;

  headers: any = {
    columns: {
      corpId: {title: 'Statement', hide: true, filter: false},
      id: {title: 'Id', hide: true, filter: false},
      calendarStepId: {title: 'Step', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => { return {cell: cell, options: this.steps}},
        renderComponent: DropdownComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeDropdown.subscribe(data => {
              let obj = this.stepContents.find(x => x.id == data.row.id)
              obj.calendarStepId = data;
              this.saveStepContent(obj, false);
            });
          }
        },
      },
      subjectId: {title: 'Subject', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => { return {cell: cell, options: this.subjects}},
        renderComponent: DropdownComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeDropdown.subscribe(data => {
              let obj = this.stepContents.find(x => x.id == data.row.id)
              obj.subjectId = data;
              this.saveStepContent(obj, false);
            });
          }
        },
      },
      topicId: {title: 'Topic', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => { return {cell: cell, options: this.topics}},
        renderComponent: DropdownComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeDropdown.subscribe(data => {
              let obj = this.stepContents.find(x => x.id == data.row.id)
              obj.topicId = data;
              this.saveStepContent(obj, false);
            });
          }
        },
      },
      maxTime: {title: 'Max time', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: TextComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeText.subscribe(data => {
              let obj = this.stepContents.find(x => x.id == data.row.id)
              obj.maxTime = Number(data.text);
              this.saveStepContent(obj, false);
            });
          }
        },
      },
      minTime: {title: 'Min time', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: TextComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeText.subscribe(data => {
              let obj = this.stepContents.find(x => x.id == data.row.id)
              obj.minTime = Number(data.text);
              this.saveStepContent(obj, false);
            });
          }
        },
      },
      showInMagnament: {
        title: 'Show in Magnament', hide: true, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: BooleanComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeBool.subscribe(data => {
              let obj = this.stepContents.find(x => x.id == data.row.id)
              obj.showInMagnament = data.bool;
              this.saveStepContent(obj, false);
            });
          }
        },
      }
    },
    actions: false,
  }

  constructor(private calendarService: CalendarService, private subjectService : SubjectService, private shared: Shared) {
  }

  ngOnInit() {
  }

  nextStep(id: number){
    this.filter.emit(id);
  }

  saveStepContent(stepContent: StepContentEntity, bool) {
    this.calendarService.saveStepContent(stepContent).subscribe( t =>{
      if(t!=null) {
        if(bool){this.stepContents.push(t);}
        this.stepContents = this.stepContents.filter(x => {return x});
      }
    });
  }

  async saveNewStepContent() {
    this.saveStepContent(this.newEntity, true);
    this.modeAdd = false;
  }

  newStepContent(){
    this.modeAdd = true;
    this.newEntity = new StepContentEntity();
    this.newEntity.corpId = this.shared.CORP_ID;
    this.newEntity.showInMagnament = true;
  }
}
